import classnames from 'classnames';
import React, { FC, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { ModalName } from '../../../../constants/ModalName';
import { ActionClickOrigin } from '../../../../utils/hooks/bi/useTrackActions/useTrackActions.types';
import { TrackBoardClickOrigin, useTrackBoardAnalytics } from '../../../../utils/hooks/bi/useTrackBoardAnalytics';
import { useModalHandlersAndOptions } from '../../../../utils/hooks/useModal';
import { AddItem } from '../../../common';
import styles from './CreateNewBoard.scss';
import { IOuter } from './CreateNewBoard.types';

export const CreateNewBoard: FC<IOuter> = ({ className }) => {
  const { openModal } = useModalHandlersAndOptions(ModalName.EditBoard);
  const { trackCreateBoardClick } = useTrackBoardAnalytics();

  const handleOpenCreateNewBoardModal = useCallback(
    (event) => {
      event.preventDefault();
      event.stopPropagation();

      openModal({ clickOrigin: ActionClickOrigin.BoardsList });

      trackCreateBoardClick(TrackBoardClickOrigin.BoardsList);
    },
    [openModal, trackCreateBoardClick],
  );

  return (
    <li className={classnames(styles.wrapper, className)}>
      <div className={classnames(styles.createNewBoard, styles.maxSize)}>
        <div className={styles.content}>
          <AddItem size="small" onClick={handleOpenCreateNewBoardModal} dataHook="create-new-board-button">
            <span className={styles.text}>
              <FormattedMessage id="boards.create-new-board" />
            </span>
          </AddItem>
        </div>
      </div>
    </li>
  );
};
